import { Environment } from '../app/models/environment'

export const environment: Environment = {
    production: false,
    name: 'dev',
    baseUrl: 'https://apisat-dev.leon-grosse.fr/apisat-api-rest',
    oauth: {
        clientId: '1vv6k54rm1fljhtog02tmdskjc',
        loginUrl: 'https://lguserpoolapisatdev.auth.eu-west-3.amazoncognito.com/oauth2/authorize',
        issuer: 'https://cognito-idp.eu-west-3.amazonaws.com/eu-west-3_V7LbxXlrw',
        logoutUrl: 'https://lguserpoolapisatdev.auth.eu-west-3.amazoncognito.com/logout',
        tokenEndpoint: 'https://lguserpoolapisatdev.auth.eu-west-3.amazoncognito.com/oauth2/token',
        userInfoEndpoint: 'https://lguserpoolapisatdev.auth.eu-west-3.amazoncognito.com/oauth2/userInfo',
        jwks: {
            keys: [
                {
                    alg: 'RS256',
                    e: 'AQAB',
                    kid: 'P3c7uJnm90q+w8dBh7KNo1WZZNFrocUILTQGI/JFnsE=',
                    kty: 'RSA',
                    n: '1wuQKBOHZ5cmxRf25x60auQUUKYhTNM_6N57tkNEBr0Zc6ubNst3T42LdUXWK6tvIjxeAlCXfkm6fMOBpxlssj_euioHEVxRYqk-h7lriEHq7UFqVv8LgYCob3-_jeujcUPyTrjcMDK4LPPGvLdNX2lh6RAWocvzJaZTh4reFT2CAhd4-wS37_NOcaq1ScTrfqKaJJFGtFd7A2TKTdhqol6eUS43uu0ZNppswVIwxq77bTRJqVTIdKiDOFngghYHAc58g-FHZr4tff_JvpuA_Dm2Z6Gh3pQYy6Sj5Xw5JSBdcFu4jCG7IIV8smuyii6z3bJsE8n0t6t0xtAwi6IJLQ',
                    use: 'sig',
                },
                {
                    alg: 'RS256',
                    e: 'AQAB',
                    kid: 'kYWeUOLqI/WpnYprQ/ZFpS22He25Lzf9dY8C4M4rXPw=',
                    kty: 'RSA',
                    n: '3twcajsSi5ATd6LYionON96OFsZg92oOPJX2KAIdJYQUQc3M1wD8Bno9seDS8igoScNCzV9lJFRU14WXfvCZ4beIJbILI4oEyLJrLoFet10c_hVO1kS30TCcOV9i4xC4qfss0vGZMHp3Tq0ekVrtzwSg-Ut5lAO5Oh_rZUvO_1vaOwfDbeXGRoFUQKYp2XzVOVQ6XCJEYkZ2aIKSsyzdyEij1nxYK9Xyxq0GOeZ0GNwCXMP8UEa7OfXBIRrQ__bny6mQ5qxaVazqo0suhoGkB27AJrzAYCu012zWFdk6dRgV5x6YIZq4VJGJ2P2WMCZD_pAsbbnjeDtrd8dLxBPhqw',
                    use: 'sig',
                },
            ],
        },
    },
}
